import React, { useState } from "react";
import StepsComponent from "../../../../components/StepsComponent/StepsComponent";
import styles from "./ReciepeManagement.module.css";
import { TextComponent } from "../../../../components";
import SubHeadingComponent from "../../../../components/SubHeadingComponent/SubHeadingComponent";
import ProductSetup from "./ProductSetup/ProductSetup";
import StationSetup from "./StationSetup/StationSetup";
import { useLocation, useNavigate } from "react-router-dom";
import IndredientsMaterial from "./Ingredients&Material/IndredientsMaterial";
import FinishedProcessParameters from "./FinishedProcessParameters/FinishedProcessParameters";
const ReciepeManagement = () => {
  const steps = [
    "Product Setup",
    "Station Setup",
    "Finished Process Parameters",
    "Ingredients & Material",
  ];
  const navigate = useNavigate();
  // const [current, setCurrent] = useState(0);

  const { search } = useLocation();

  const current = Number(new URLSearchParams(search).get("step")) || 0;
  const onNext = () => {
    if (current < steps.length - 1) {
      navigate(`?step=${current + 1}`);
    }
  };

  const onPrev = () => {
    if (current > 0) {
      navigate(`?step=${current - 1}`);
    }
  };

  return (
    <div>
      <div className={styles.stepContainer}>
        <StepsComponent
          backIcon={true}
          steps={steps}
          currentStepIndex={current}
          onPrev={onPrev}
          onNext={onNext}
        />
      </div>
      <div className={styles.compMainCont}>
        {current == 0 ? (
          <ProductSetup />
        ) : current == 1 ? (
          <StationSetup />
        ) : current == 2 ? (
          <FinishedProcessParameters />
        ) : current == 3 ? (
          <IndredientsMaterial />
        ) : null}
      </div>
    </div>
  );
};

export default ReciepeManagement;
